import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { DetailRow, ErrorState, LoadingState, PageTitle, useAsync } from '../PortalUi';
import { currentCustomerSession, fetchProfile } from '../../../../services/request/CustomerPortal';
import { useTranslation } from '../../../../i18n';

export default function PortalProfile() {
  const { t, intlLocale } = useTranslation();
  const profile = useAsync(fetchProfile, []);
  const session = currentCustomerSession();
  const address = [profile.data?.address, profile.data?.city, profile.data?.state, profile.data?.pincode].filter(Boolean).join(', ');

  return (
    <Box>
      <PageTitle kicker={t('portal.profile.kicker')} title={t('portal.profile.title')} subtitle={t('portal.profile.subtitle')} />
      {profile.error ? <ErrorState message={profile.error} onRetry={profile.reload} /> : null}
      {profile.loading && !profile.data ? <LoadingState label={t('portal.profile.loading')} /> : null}
      <Box sx={{ display: 'grid', gap: 3, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, alignItems: 'start' }}>
        {profile.data ? (
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              {t('portal.profile.account')}
            </Typography>
            <DetailRow label={t('portal.profile.name')} value={profile.data.name} />
            <DetailRow label={t('portal.profile.email')} value={profile.data.email} />
            <DetailRow label={t('portal.profile.mobile')} value={profile.data.contactNumber} />
            <DetailRow label={t('portal.profile.address')} value={address || undefined} />
          </Paper>
        ) : null}
        <Box sx={{ display: 'grid', gap: 3 }}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              {t('portal.profile.requests')}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mt: 2 }}>
              <Button component={RouterLink} to="/customer/request-funds" variant="contained">
                {t('portal.home.requestFunds')}
              </Button>
              <Button component={RouterLink} to="/customer/referrals" variant="outlined">
                {t('portal.home.refer')}
              </Button>
            </Box>
          </Paper>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              {t('portal.profile.sessionTitle')}
            </Typography>
            <Typography color="text.secondary">
              {t('portal.profile.sessionBody')}
              {session
                ? ` ${t('portal.profile.sessionUntil', {
                    date: session.expiresAt.toLocaleDateString(intlLocale, { day: 'numeric', month: 'short', year: 'numeric' }),
                  })}`
                : ''}
            </Typography>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
}
